import React from 'react'

interface Location {
  slug: string
  name_default: string
}

interface VendorsSearchLocationProps {
  locations: Location[]
}

const VendorsSearchLocation: React.FC<VendorsSearchLocationProps> = ({ locations }) => {
  // Group locations by country
  const groupedLocations = locations.reduce((acc, location) => {
    const parts = location.name_default.split(', ')
    const country = parts[parts.length - 1]

    if (!acc[country]) {
      acc[country] = []
    }
    acc[country].push(location)
    return acc
  }, {} as Record<string, Location[]>)

  return (
    <div>
      <div className="header">
        <h2>Locations</h2>
      </div>
      <div className="d-flex flex-column justify-content-center gap-4">
        {Object.entries(groupedLocations).map(([country, locations]) => (
          <div className="d-flex flex-column gap-2" key={country}>
            <h3>{country}</h3>
            <div className="articles__list d-flex justify-content-start gap-4">
              {locations.map((location) => (
                <div className="article__block d-flex d-sm-block" key={location.slug}>
                  <div className="article__data">
                      <h5>
                        <a href={`search/${location.slug}`}>
                          {location.name_default}
                        </a>
                      </h5>
                    <div className='content_line d-none d-sm-block'></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default VendorsSearchLocation
